module.exports = __webpack_public_path__ + "img/ic-acessibilidade-libras-ac.21e95e5a.svg";